<template>
  <v-list-item
    v-if="!hasChildren"
    class="mb-1 pdf-menu-list-item book-index"
    :class="{ selected: itemSelected }"
    :value="item.id"
    :data-id="item.id"
    data-testid="TocItem"
    @click="listItemSelected"
  >
    <div class="d-flex align-center justify-space-between gap-3">
      <div class="d-flex align-center gap-3">
        <v-icon v-if="hasChildren" :size="16">fa-light fa-angle-down</v-icon>
        <div>{{ item.name }}</div>
      </div>
      <div class="item-page-number">{{ item.page }}</div>
    </div>
  </v-list-item>

  <v-list-group v-else expand-icon="" collapse-icon="" :value="item.id">
    <template #activator="{ props, isOpen }">
      <v-list-item v-bind="props" class="mb-1 pdf-menu-list-item section" :class="{ selected: isOpen }">
        <div class="d-flex align-center justify-space-between gap-3">
          <div class="d-flex align-center gap-3">
            <v-icon :size="16">fa-light fa-angle-{{ isOpen ? "up" : "down" }}</v-icon>
            <div>{{ item.name }}</div>
          </div>
          <div class="item-page-number">{{ item.page }}</div>
        </div>
      </v-list-item>
    </template>

    <PdfMenuListItem v-for="child in item.children" :key="child.id" :item="child" :product-variant="productVariant" />
  </v-list-group>
</template>

<script lang="ts">
import { usePdfStore } from "~/stores/pdfStore"

export default {
  props: {
    item: {
      required: true,
      type: Object as any,
    },
    productVariant: {
      required: true,
      type: String,
    },
  },

  setup() {
    const pdfStore = usePdfStore()
    return { pdfStore }
  },

  computed: {
    listGroupOpen() {
      return this.pdfStore.recursiveChildrenSeeker(this.pdfStore.currentFile.table_of_contents).includes(this.item.id)
    },

    hasChildren() {
      return this.item.children.length > 0
    },

    worksheetsRoute() {
      return ["darba-lapas", "parbaudes-darbi"].includes(this.$route.path.split("/")[1])
    },

    isWorksheetVariant() {
      return ["simple_worksheets", "test_works"].includes(this.productVariant)
    },

    itemSelected() {
      if (this.worksheetsRoute || this.isWorksheetVariant) {
        return this.item.slug === this.$route.query.w
      } else {
        const upperPageLimit = this.pdfStore.intervalUpperLimit(this.item.id)
        if (upperPageLimit !== -1) {
          return this.pdfStore.currentPage >= this.item.page && this.pdfStore.currentPage < upperPageLimit
        } else {
          return this.pdfStore.currentPage >= this.item.page
        }
      }
    },

    iframeDocument() {
      return (document.getElementsByClassName("pdf-viewer-iframe")[0] as any).contentDocument
    },
  },

  methods: {
    listItemSelected() {
      if (this.worksheetsRoute || this.isWorksheetVariant) {
        navigateTo(`${this.$route.path.split("?")[0]}?w=${this.item.slug}`)
      } else {
        const itemPageElement = this.iframeDocument.querySelector(`.page[data-page-number="${this.item.page}"]`)
        itemPageElement?.scrollIntoView()
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.pdf-menu-list-item
  border-radius: 24px
  .item-page-number
    letter-spacing: 0.1px
    line-height: 20px
    font-weight: 400
    font-size: 16px
    color: rgba(0, 0, 0, 0.6)
  &.section
    &.selected
      background: rgba(0, 0, 0, 0.08)
  &.book-index
    &.selected
      background: #FFF1AE
  &:hover
    cursor: pointer
    background: rgba(0, 0, 0, 0.04)
</style>
